import styled from 'styled-components';

export const StyledHeader = styled.h1`
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 0.5em;
  color: rgb(33, 133, 208);
  display: flex;
  align-items: center;
  gap: 5px;
`

export const StyledNoResults = styled.h1`
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.5em;
  text-align: center;
`

export const StyledHerdGroupsWrapper = styled.div`
 .error-herd-group {
   >div {
    color: red !important; 
   }
 }
`